import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CoachingPlaylistIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "CoachingPlaylist",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "m29.92 21.17-.94 4.23c-.4 1.8-2.17 2.93-3.97 2.53l-1.1-.23c-1.8-.4-2.93-2.17-2.53-3.97l.94-4.24a3.31 3.31 0 0 1 3-2.58c-.36-5.4-4.52-9.7-9.46-9.7s-9.1 4.27-9.46 9.67a3.3 3.3 0 0 1 3.28 2.6l.94 4.24c.4 1.8-.73 3.57-2.53 3.97l-1.1.23c-1.8.4-3.57-.73-3.97-2.53l-.94-4.23c-.3-1.36.27-2.72 1.36-3.46v-.3C3.58 10.02 9.15 4 15.85 4s12.28 6.02 12.42 13.41v.12a3.3 3.3 0 0 1 1.65 3.64"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M6.43 18.72c-.63 0-1.14-.51-1.14-1.14v-3.43c0-5.67 4.61-10.29 10.29-10.29s10.29 4.61 10.29 10.29v3.43a1.14 1.14 0 1 1-2.28 0v-3.43c0-4.41-3.59-8-8-8s-8 3.59-8 8v3.43c0 .63-.51 1.14-1.14 1.14Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M25.09 29h-.76c-2.31 0-4.19-1.88-4.19-4.19v-4.19c0-2.31 1.88-4.19 4.19-4.19h.76c2.31 0 4.19 1.88 4.19 4.19v4.19c0 2.31-1.88 4.19-4.19 4.19m-.76-10.29c-1.05 0-1.9.85-1.9 1.91v4.19c0 1.05.85 1.9 1.9 1.9h.76a1.9 1.9 0 0 0 1.9-1.9v-4.19c0-1.05-.85-1.91-1.9-1.91zM6.81 29h-.76c-2.31 0-4.19-1.88-4.19-4.19v-4.19c0-2.31 1.88-4.19 4.19-4.19h.76c2.31 0 4.19 1.88 4.19 4.19v4.19C11 27.12 9.12 29 6.81 29m-.76-10.29c-1.05 0-1.9.85-1.9 1.91v4.19c0 1.05.85 1.9 1.9 1.9h.76a1.9 1.9 0 0 0 1.9-1.9v-4.19c0-1.05-.85-1.91-1.9-1.91z"
      })]
    })
  }));
};
CoachingPlaylistIcon.displayName = 'CoachingPlaylistIcon';